<label class="fx-row fx-flex-1 fx-align-center fx-justify-space-between"
  ><span>
    {{ label() }}
    <ng-content select="[optionBlockLabel]"></ng-content> </span
  ><ng-content></ng-content>
</label>
